import React from 'react';
import { _ } from '../../../functions/translator';

class DescriptionInfo extends React.Component{

    render(){

        let descriptionValue = this.props.card.attributes.description ? this.props.card.attributes.description : _('Ninguna')

        let description = _("Observación")
        if (this.props.customcard) {
            if (!this.props.customcard.attributes.description) return <div></div>
            description = this.props.customcard.attributes.description
        }

        return (
            <div>
                <div className='info-container'>
                    <p className='card-text'>{ description }</p>
                    <span className='text card-description'>{ descriptionValue }</span>
                </div>
            </div>
        );
    }
}

export default DescriptionInfo;